import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Drawer } from '@mui/material';
import Chat from 'modules/chats/common/Chat';


type InstantChatButtonProps = {
    code: string,
    name: string,
}

const InstantChatButton = ({code, name}: InstantChatButtonProps) => {
    const {t} = useTranslation();
    const [state, setState] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const open = () => {
        setState( true);
        navigate(location, {state: {drawer: code}});
    };

    useEffect(() => {
        if (!location.state?.drawer)
            setState( false)
    }, [location]);

    return (
        <>
            <Button onClick={open}>{t('chat')}</Button>
            <Drawer
                anchor="right"
                open={state}
                onClose={() => navigate(-1)}
                sx={{zIndex: 1202}}
            >
                <Chat
                    onClose={() => navigate(-1)}
                    code={code}
                    name={name}
                />
            </Drawer>
        </>
    );
};

export default InstantChatButton;
